import React, { useState, useEffect } from 'react';
import { getBioContent } from '../utils/csvParser';

function Home() {
  const [bioContent, setBioContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [mutedVideos, setMutedVideos] = useState({});

  useEffect(() => {
    const loadBioContent = async () => {
      try {
        const content = await getBioContent();
        setBioContent(content);
      } catch (error) {
        console.error('Error loading bio content:', error);
        setBioContent('Error loading bio content. Please try refreshing the page.');
      } finally {
        setLoading(false);
      }
    };

    loadBioContent();
  }, []);

  const toggleVideoMute = (videoId) => {
    setMutedVideos(prev => ({
      ...prev,
      [videoId]: !prev[videoId]
    }));
  };

  if (loading) {
    return (
      <div className="page">
        <div className="page-header">
          <h1 className="page-title">Loading...</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      {/* Hero Section - 2 Column Layout with Matrix Effects */}
      <div className="hero-section-2col">
        <div className="hero-image matrix-image-container">
          <div className="portfolio-video matrix-video-container">
            <video
              className="matrix-video"
              src="/media/images/STRANGELOVE_SETS.MOV"
              title="Strangelove Sets Video"
              loop
              muted={!mutedVideos['video3']}
              autoPlay
              playsInline
              onClick={() => toggleVideoMute('video3')}
              volume="0.6"
            />
            <div className="video-overlay">
              <div className="video-controls">
                <span className="muted-indicator">{mutedVideos['video3'] === false ? '🔊' : '🔇'}</span>
                <span className="click-to-unmute">{mutedVideos['video3'] === false ? 'Click to mute' : 'Click to unmute'}</span>
              </div>
            </div>
          </div>
          <h3 className="video-caption">click to unmute</h3>
        </div>

        <div className="hero-content">
          <div className="hero-description">
            <h1 className="hero-title matrix-title">Music, Storytelling, and Sound Design</h1>
            <p className="matrix-description">I'm Truman Gaynes, a New York based music technologist and licensing coordinator dedicated to connecting sound and story across entertainment, fashion, and brand worlds. I compose and design sound daily, blending technical accumen with creative instinct, while furthering my expertise in music licensing and administration.</p>
          </div>
        </div>
      </div>

      {/* Matrix Content Flow */}
      <div className="matrix-content-flow">
        <div className="matrix-info-item">
          <h3 className="matrix-info-title">education</h3>
          <p className="matrix-info-content">NYU - Music Technology, Music Business</p>
        </div>
        <div className="matrix-info-item">
          <h3 className="matrix-info-title">focus</h3>
          <p className="matrix-info-content">Composition, Licensing, Sound Design</p>
        </div>
        <div className="matrix-info-item">
          <h3 className="matrix-info-title">experience</h3>
          <p className="matrix-info-content">Turner Music, NYFW, Project Wayfarer</p>
        </div>
      </div>

      {/* My Story and Video Section */}
      <div className="story-video-section">
        <div className="my-story">
          <h3 className="story-title">My Story</h3>
          <div className="story-content">
            <p>My background in Music Technology and the Business of Entertainment (NYU) bridges the creative and logistical sides of sound. I've contributed to original compositions for New York Fashion Week, interactive scores for indie games, and custom music pitches at Tuner Music for global brands.</p>
          </div>
        </div>

        <div className="video-showcase">
          <div className="portfolio-video matrix-video-container">
            <video
              className="matrix-video"
              src="/media/images/Life On Mars with Nick Graham - Nick Graham (720p, h264).mp4"
              title="Portfolio Video"
              loop
              muted={!mutedVideos['video1']}
              autoPlay
              playsInline
              onClick={() => toggleVideoMute('video1')}
              volume="0.6"
            />
            <div className="video-overlay">
              <div className="video-controls">
                <span className="muted-indicator">{mutedVideos['video1'] === false ? '🔊' : '🔇'}</span>
                <span className="click-to-unmute">{mutedVideos['video1'] === false ? 'Click to mute' : 'Click to unmute'}</span>
              </div>
            </div>
          </div>
          <h3 className="video-caption">click to unmute</h3>
        </div>
      </div>

      {/* Video and Story Section - Video Left, Text Right */}
      <div className="video-story-section">
        <div className="video-showcase">
          <div className="portfolio-video matrix-video-container">
            <video
              className="matrix-video"
              src="/media/images/Nick Graham S_S18 Atlantis - Nick Graham (720p, h264).mp4"
              title="Music Portfolio Video"
              loop
              muted={!mutedVideos['video2']}
              autoPlay
              playsInline
              onClick={() => toggleVideoMute('video2')}
              volume="0.6"
            />
            <div className="video-overlay">
              <div className="video-controls">
                <span className="muted-indicator">{mutedVideos['video2'] === false ? '🔊' : '🔇'}</span>
                <span className="click-to-unmute">{mutedVideos['video2'] === false ? 'Click to mute' : 'Click to unmute'}</span>
              </div>
            </div>
          </div>
          <h3 className="video-caption">click to unmute</h3>
        </div>

        <div className="my-story">
          <div className="story-content">
            <p>I'm drawn to the psychology of sound. How certain tones, rhythms, and textures can instantly communicate identity. My work in fashion, games, and branded storytelling continues to deepen my passion for sonic branding: using music as a language that defines how a story is perceived and remembered.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
